<template>
	<div :class="{'conversation-bottom-box': true, 'ww-shop': currentShop.serviceType == $store.state.TYPES.WANGWANG}">
		<div class="today-reception">
			<span>今日接待：</span>
			<span>{{ todayReception }}</span>
		</div>
		<div class="current-wait">
			<span>排队人数：</span>
			<span>{{ currentWait }}</span>
		</div>
		<a class="icon icon-maichu seller-center-btn" :href="sellerCenterLink" target="_blank"></a>
	</div>
</template>

<script>
export default {
	name: 'conversationFooter',
	data () {
		return {
			todayReception: '-',
			currentWait: '-',
			sellerCenterLink: '',
			receptionInterval: null
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		}
	},
	watch: {
		currentShop: {
			deep: true,
			handler (now, old) {
				this.getReceptionRealTimeData();
				if (now.id != old.id) {
					this.sellerCenterLink = API_ROOT.cUrl + '/wwim/wwShopOrderIndex?shopId=' + now.id;
				}
			}
		}
	},
	methods: {
		// 轮询今日接待和当前排队人数
		getReceptionRealTimeData () {
			var self = this;

			self.todayReception = '-';
			self.currentWait = '-';
			self.receptionInterval && clearInterval(self.receptionInterval);
			self.receptionInterval = setInterval(function(){
				submit();
			}, 10000);

			submit();

			function submit() {
				var data = {
					serviceType: self.currentShop.serviceType,
					shopId: self.currentShop.id
				};
				self.$axios.post(API_ROOT.url + '/CustomerStatusApi.getCustomerServiceStat', data).then(result => {
					if (result.status && result.data) {
						self.todayReception = (result.data.todayServiceCount === null || result.data.todayServiceCount === undefined) ? '-' : result.data.todayServiceCount;
						self.currentWait = (result.data.currWaittingCount === null || result.data.currWaittingCount === undefined) ? '-' : result.data.currWaittingCount;
					}
				});
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/conversation/conversationFooter.vue